module.exports = __webpack_public_path__ + "static/media/BR.38cbd2dd.svg";